<template>
  <div class="unsupported-bank-popup">
    <popup :buttons="buttons" :close-action="popupClosed">
      <template v-slot:title>
        <img class="logo-image" :src="require('@/assets/onboarding/big-icon-unsupported.svg')">
        <div class="popup-title">מצטערים אבל המערכת שלנו לא תומכת כרגע ב{{ bankDisplayName }}</div>
      </template>
      <template v-slot:content>
        <div class="description">
          <span>האם זה חשבון הבנק העיקרי שלך?</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import Segment from '../../Segment';
import router from '../../router';
import CommunicationStateApi from '../../api/CommunicationStateApi';

export default {
  name: 'UnsupportedBankPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  props: {
    sourceName: {
      type: String,
      required: true,
    },
    bankDisplayName: {
      type: String,
      required: true,
    },
    waitingListName: {
      type: String,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('UnsupportedBanksPopupEntered', { sourceName: this.sourceName });
  },
  computed: {
    buttons() {
      return [
        {
          title: 'כן, עדכנו אותי כשתתמכו',
          action: this.primaryBankSelected,
          size: 'slim',
        },
        {
          title: 'לא, אפשר להמשיך בלעדיו',
          action: this.continueWithoutSelected,
          variant: 'secondary',
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    primaryBankSelected() {
      Segment.trackUserInteraction('PrimaryBankClicked', { sourceName: this.sourceName });
      CommunicationStateApi.disableBoti(`Unsupported: ${this.waitingListName}`);
      this.closeModal();
      router.push({ path: '/unsupported-bank', query: { sourceName: this.sourceName, sourceDisplayName: this.bankDisplayName } });
    },
    continueWithoutSelected() {
      Segment.trackUserInteraction('ContinueWithoutBankClicked', { sourceName: this.sourceName });
      this.closeModal();
    },
    popupClosed() {
      Segment.trackUserInteraction('UnsupportedBanksDecisionClosed', { sourceName: this.sourceName });
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>

  .unsupported-bank-popup {
    .action-icon {
      margin-bottom: 15px;
    }

    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 18px;
      text-align: center;
      padding: 0 18px 0 18px;
    }

    .logo-image {
      width: 100%;
      text-align: center;
      height: 110px;
      margin-top: 20px;
      margin-bottom: 30px;
    }

    .description {
      margin-bottom: 60px;
      line-height: 20px;
      text-align: center;
      padding: 0 10px 0 10px;

      .bold {
        font-weight: bold;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/UnsupportedBankPopup.vue